import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SignupService } from '../../services/signup.service';
import { WatcherService } from 'src/app/services/watcher.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { TitleAndDescriptionsService } from 'src/app/services/titles-and-descriptions.service';
import { shopFromWhatsNextDocuments } from 'src/app/shared/contents/shop-from/shop-from-whats-next-document';
@Component({
  selector: 'app-hosts',
  templateUrl: './hosts.component.html',
  styleUrls: ['./hosts.component.css'],
})
export class HostsComponent implements OnInit {
  paramCountryCode;
  countryDetails;
  allCountryList;
  hostList;
  hostRate = 0;
  hasConsolidation = false;
  hasItemPhotos = false;
  hasRepacking = false;
  hasStorage = false;
  destinationCountry = '';
  hasFrench;
  hasJapanese;
  hasMandarin;
  hasRussian;
  hasSpanish;
  hasEnglish;
  languageArray = [];
  hostCountries;
  countryFrom;
  // ELF AUTH
  token;
  userID;
  elf_auth = 0;

  shopFromWhatsNextContents = shopFromWhatsNextDocuments;
  currentShopFromContent: any;
  thereShopFromContent: boolean = false;

  constructor(
    private route: ActivatedRoute,
    public signUpService: SignupService,
    private watcherService: WatcherService,
    private router: Router,
    private store: Store<AppState>,
    private tAdService: TitleAndDescriptionsService,
    private _cdr: ChangeDetectorRef
  ) {}
  lang;
  hostsCountriesIncludeParamCountry = true;
  hostListLengthIsZero = false;
  paramProductUrl;
  ngOnInit(): void {
    this.watcherService.getLang().subscribe((lang) => {
      this.lang = lang;
    });

    this.paramCountryCode =
      this.route.snapshot.paramMap.get('countryCode').toUpperCase() || 'AU';
    this.paramProductUrl = this.route.snapshot.queryParamMap.get('product_url');
    this.currentShopFromContent = this.shopFromWhatsNextContents.find(
      (content) => content.country_code == this.paramCountryCode.toUpperCase()
    );
    if (this.currentShopFromContent) {
      this.thereShopFromContent = true;
    }

    this.route.paramMap.subscribe((params) => {
      this.paramCountryCode = params.get('countryCode')?.toUpperCase() || '';

      this.signUpService.getHostCountries().subscribe({
        next: (list) => {
          if (list && list['data']) {
            this.hostCountries = list['data'];
            this.hostsCountriesIncludeParamCountry = this.hostCountries.some(
              (hc) =>
                hc.code.toUpperCase() === this.paramCountryCode.toUpperCase()
            );

            if (this.hostsCountriesIncludeParamCountry) {
              this.countryFrom = this.paramCountryCode.toUpperCase();
            } else {
              this.countryFrom = '';
            }
            this._cdr.markForCheck();
            this._cdr.detectChanges();
          }
        },
        error: (err) => {},
      });
      this.currentShopFromContent = this.shopFromWhatsNextContents.find(
        (content) => content.country_code === this.paramCountryCode
      );
      this.thereShopFromContent = !!this.currentShopFromContent;

      this.signUpService
        .getHostCountryByCountryCode(this.paramCountryCode.toUpperCase())
        .subscribe({
          next: (data) => {
            if (data && data['data']) {
              this.countryDetails = data;
              const countryName = data['data']['name'];
              let shopFromTitle = `Global Shop: Fast Shipping From ${countryName} - Shippn`;
              if (shopFromTitle.length <= 60) {
                this.tAdService.updateWebPageTitle(shopFromTitle);
              } else {
                const countryCode = data['data']['code'];
                if (countryCode === 'US') {
                  this.tAdService.updateWebPageTitle(
                    `Global Shop: Fast Shipping From America - Shippn`
                  );
                } else if (countryCode === 'AE') {
                  this.tAdService.updateWebPageTitle(
                    `Global Shop: Fast Shipping From United Arab Emirates - Shippn`
                  );
                }
              }
              this.tAdService.updateWebsiteDescription(
                `Shop confidently with Shippn and enjoy fast shipping straight from ${countryName}. Explore our diverse range of products and enjoy swift deliveries`
              );
            }
          },
          error: (err) => {},
        });

      this.signUpService
        .getHostMembersByCountryCode(this.paramCountryCode.toUpperCase())
        .subscribe({
          next: (data) => {
            if (data && data['data']) {
              this.hostList = data['data'];
              this.hostListLengthIsZero = this.hostList.length === 0;

              if (this.hostList.length > 0) {
                this.hostList = this.hostList.filter(
                  (host) =>
                    host.name.toLowerCase() !== 'test' &&
                    ![
                      '64ad4904fd26fa274c2f5b5d',
                      '64db269bfd26fa0d0c51a17d',
                    ].includes(host.id)
                );

                this.hostList.forEach((host) => {
                  this.signUpService
                    .getHostMemberReviewsByID(host.id)
                    .subscribe({
                      next: (data) => {
                        if (data && data['data']) {
                          let revCount = data['data'].reduce(
                            (acc, rev) => acc + (rev.reviews?.length || 0),
                            0
                          );
                          host.reviewsCount = revCount;
                        }
                      },
                      error: (err) => {},
                    });
                });

                this.hostList.sort((a, b) => b.is_list - a.is_list);
                this.languageArray = Array.from(
                  new Set(this.hostList.flatMap((host) => host.language))
                );
              } else {
                this.hostList = [];
              }
            }
          },
          error: (err) => {},
        });

      this.signUpService.getAllCountries().subscribe({
        next: (data) => {
          if (data && data['data']) {
            this.allCountryList = data['data'];
          }
        },
        error: (err) => {},
      });

      window.scrollTo(0, 0);

      this.store.select('auth').subscribe((state) => {
        this.token = state.token;
        this.userID = state.user?.id;
      });

      if (this.userID && this.token) {
        this.signUpService.getUserByUserID(this.userID, this.token).subscribe({
          next: (data) => {
            if (data && data['data'] && data['data'].right) {
              this.elf_auth = +data['data'].right[0].elf_authorization;
            }
          },
          error: (err) => {},
        });
      }
    });
  }
  getHostsFrom(countryCode) {
    this.router.navigate([
      '/',
      this.lang,
      'shop-from',
      countryCode.toLowerCase(),
    ]);
  }
  filterLanguages() {}
  filterWithAPI(hasConsolidation, hasItemPhotos, hasRepacking, hasStorage) {
    this.hasConsolidation = hasConsolidation;
    this.hasItemPhotos = hasItemPhotos;
    this.hasRepacking = hasRepacking;
    this.hasStorage = hasStorage;
    this.languageArray = [];
    this.signUpService
      .filterHostsByCountryCode(
        this.paramCountryCode.toUpperCase(),
        this.destinationCountry,
        this.hasConsolidation,
        this.hasItemPhotos,
        this.hasRepacking,
        this.hasStorage
      )
      .subscribe((data) => {
        for (let index = 0; index < data['data'].length; index++) {
          for (
            let hostIndex = 0;
            hostIndex < data['data'][index].language.length;
            hostIndex++
          ) {
            if (
              !this.languageArray.includes(
                data['data'][index].language[hostIndex]
              )
            ) {
              this.languageArray.push(data['data'][index].language[hostIndex]);
            }
          }
        }
      });
  }
  selectCountry(countryCode) {
    if (this.destinationCountry == '') {
      this.destinationCountry = countryCode;
    } else if (this.destinationCountry != countryCode) {
      this.destinationCountry = countryCode;
    } else {
      this.destinationCountry = '';
    }
    this.filterWithAPI(
      this.hasConsolidation,
      this.hasItemPhotos,
      this.hasRepacking,
      this.hasStorage
    );
  }
  goLocation(path) {
    this.router.navigate(['/', this.lang, 'shop-from', path.toLowerCase()]);
  }
}
